<template>
    <div class="centers">
        <div class="timeTab clearfix" v-show="startTime&&endTime">
            <p class="floatL">Selected：</p>
            <span class="floatL">{{startTime}}</span>
            <span class="floatL" style="padding: 0 10px;">~</span>
            <span class="floatL">{{endTime}}</span>
            <p class="floatL delBtn" @click="clearTime()">Clear</p>
        </div>
        <div class="timeTab clearfix" v-show="!startTime||!endTime">
            <el-button size="small" class="floatL violet" @click="timeVisible=true">
                <i class="iconfont icon-filter" style="font-size:18px; cursor:pointer; padding-left: 8px;"></i>Screen time
            </el-button>
        </div>
        <div class="tableTab">
            <template>
                <el-table :data="tableData" border style="width: 100%;" @filter-change="handleFilterChange" v-loading="loading">
                    <el-table-column prop="date" label="Date">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="Type"
                        :filters="allTypes"

                        :filter-multiple="false"
                        column-key="type"
                        filter-placement="right-start"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.type==='in'">Top-up</span>
                            <span v-else-if="scope.row.type==='out'">deduction</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="projectName"
                        label="Item"
                        :filters="allProject"

                        :filter-multiple="false"
                        column-key="projectName"
                        filter-placement="right-start"
                    ></el-table-column>
                    <el-table-column prop="budget" label="Amount">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type==='in'">+ {{scope.row.budget}}</span>
                            <span v-else-if="scope.row.type==='out'">- {{scope.row.budget}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance" label="Balance"></el-table-column>
                    <el-table-column label="Operation" width="180" align="center">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                icon="el-icon-document"
                                class="green"
                                @click="getDetail(scope.row)"
                            >detail</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <!-- 分页 -->
            <div class="block" style="text-align: center;margin-top:2em">
                <el-pagination
                @size-change="handelSizechange"
                background
                @current-change="handelCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalcount"
                >
                <!-- 总条数this.totalcount=数据传过来的数量 -->
                </el-pagination>
            </div>
        </div>
        <!-- 时间选择弹窗 -->
        <el-dialog
            title="Date range"
            :visible.sync="timeVisible"
            :close-on-click-modal="false"
            width="800px"
            >
            <div class="popTab">
                <p class="perItem" style="margin-bottom:20px;">
                    <template>
                        <el-radio v-model="timeRadio" label="1">Last 7 days</el-radio>
                        <el-radio v-model="timeRadio" label="2">Last 30 days</el-radio>
                        <el-radio v-model="timeRadio" label="3">Last 90 days</el-radio>
                        <el-radio v-model="timeRadio" label="4">Custom</el-radio>
                    </template>
                </p>
                <p class="perItem" v-show="timeRadio==='4'">
                    <span style="display:inline-block; width:100px; text-align:right">Start time</span>
                    <el-date-picker
                        v-model="startTime_pop"
                        type="datetime"
                        :picker-options="startDataPicker"
                        format="yyyy-MM-dd HH:mm"
                        default-time="12:00:00"
                        placeholder="selection start time"
                    ></el-date-picker>
                </p>
                <p class="perItem" v-show="timeRadio==='4'">
                    <span style="display:inline-block; width:100px; text-align:right">End time</span>
                    <el-date-picker
                        v-model="endTime_pop"
                        type="datetime"
                        :picker-options="endDatePicker"
                        format="yyyy-MM-dd HH:mm"
                        default-time="12:00:00"
                        placeholder="selection end time"
                    ></el-date-picker>
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="info" @click="cancelTime()">Cancel</el-button>
                <el-button type="primary" @click="sureTime()">Sure</el-button>
            </div>
        </el-dialog>
        <!-- 详情弹窗 -->
        <el-dialog
            title="Statement detail"
            :visible.sync="detailVisible"
            :close-on-click-modal="false"
            width="800px"
            >
            <div class="popTab">
                <ul class="perPart">
                    <li class="header">
                        <b>Basic info</b>
                    </li>
                    <li>
                        <span>Creation time：</span>
                        <b>{{flowBillDetail.basic_info.date}}</b>
                    </li>
                    <li>
                        <span>Type：</span>
                        <template>
                        <b v-show="flowBillDetail.basic_info.type==='in'">Top-up</b>
                        <b v-show="flowBillDetail.basic_info.type==='out'">deduction</b>
                        </template>
                    </li>
                    <li>
                        <span>Item：</span>
                        <b>{{flowBillDetail.basic_info.projectName}}</b>
                    </li>
                    <li>
                        <span>Amount：</span>
                        <b>{{flowBillDetail.basic_info.budget}}</b>
                    </li>
                </ul>
                <ul class="perPart">
                    <li class="header">
                        <b>Payment info</b>
                    </li>
                    <li>
                        <span>Payment serial no.：</span>
                        <b>{{flowBillDetail.pay_info.pay_code}}</b>
                    </li>
                    <li>
                        <span>Paid date：</span>
                        <b>{{flowBillDetail.pay_info.pay_time}}</b>
                    </li>
                    <li>
                        <span>Payment mode：</span>
                        <b>{{flowBillDetail.pay_info.pay_method}}</b>
                    </li>
                    <li>
                        <span>Actual payment：</span>
                        <b>{{flowBillDetail.pay_info.pay_money}}</b>
                    </li>
                    <li>
                        <span>Balance：</span>
                        <b>{{flowBillDetail.pay_info.pay_balance}}</b>
                    </li>
                </ul>
                <ul class="perPart">
                    <li class="header">
                        <b>Associated order</b>
                    </li>
                    <li class="clearfix">
                        <span class="floatL">Order no.：</span>
                        <b class="floatL clearfix">
                        <em
                            class="floatL"
                            style="margin-right:10px;"
                            v-for="(item, index) in flowBillDetail.order_info.contact_code"
                            :key="index"
                        >{{item}}</em>
                        </b>
                    </li>
                    <li class="clearfix">
                        <span class="floatL">Description：</span>
                        <b class="floatL">{{flowBillDetail.order_info.contact_con}}</b>
                    </li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="detailVisible=false">Sure</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getTransaction, getTransactionDetail } from '../api/finance'
import { getToken, removeToken } from '../../utils/auth'
import { setItem1, getItem1, removeItem1 } from '../../utils/locstorage'
import { getPlanUsage } from '../api/home'
import store from '@/store'

export default {
  data () {
    return {
      customer_id: '',
      timeVisible: false,
      detailVisible: false,
      timeRadio: '1',
      startTime: '',
      endTime: '',
      startTime_pop: '',
      endTime_pop: '',
      type: '', // filter 过滤类型
      projectName: '', // filter 过滤项目
      hasTime: false, // 当用户已开通套餐则请求数据，否则不请求列表
      loading: false,
      allTypes: [
        {
          text: 'Top-up',
          value: '1'
        },
        {
          text: 'deduction',
          value: '-1'
        }
      ],
      allProject: [
        {
          text: 'Other',
          value: '0'
        },
        {
          text: 'Top-up', // 充值
          value: '1'
        },
        {
          text: 'Shipping Cost', // 运费(Vat算运费)
          value: '2'
        },
        {
          text: 'Payment Fee', // 手续费
          value: '5'
        },
        {
          text: 'ltemCosts', // 订单处理费
          value: '8'
        },
        {
          text: 'Storage', // 仓库使用费
          value: '6'
        },
        {
          text: 'Insurance', // 仓库保险费
          value: '11'
        },
        {
          text: 'Add on service', // 增值服务费
          value: '12'
        },
        {
          text: 'Packing Material', // 包材费
          value: '15'
        },
        {
          text: 'Restocking', // 返架费
          value: '16'
        }
      ],
      searchForm: {
        startTime: '',
        endTime: '',
        type: 'all',
        project: '项目'
      },
      tableData: [

      ],
      flowBillDetail: {
        basic_info: {
          // date: "2019/05/21 12:12",
          // type: "out",
          // project: "打包费",
          // budget: "200"
        },
        pay_info: {
          // pay_code: "344210011",
          // pay_time: "2019/03/03 12:25",
          // pay_method: "paypal",
          // pay_money: "160",
          // pay_balance: "220"
        },
        order_info: {
          // contact_code: [],
          // contact_con:"waybill#AR20362019011802 total debit is 59.84. 美国 EEXPHKW cost 59.84,weight is 0.500KG"
        }
      },
      pageNum: 1,
      pageSize: 10,
      totalcount: 0,
      // 开始时间、结束时间不能超过当前日期； 结束时间不能早于开始日期
      startDataPicker: this.beginDate(),
      endDatePicker: this.processDate()
    }
  },
  mounted () {
    if (getItem1('play')) {
      store.dispatch('updatemenu', '/Finance')
      this.$router.push({
        name: 'rechargeOrder'
      })
    }
  },
  created () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }

    // 获取初始，时间
    const params = {
      customer_id: this.customer_id,
      warehouse_id: 18
    }
    getPlanUsage(params).then(response => {
      if (response.data.ask === 1) {
        this.startTime = response.data.data.billing_date
        this.endTime = response.data.data.expired
        this.getList()
        this.hasTime = true
      } else {
        // 没有时间不请求数据
        this.tableData = []
        this.totalcount = 0
        this.hasTime = false
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getList () {
      const params = {
        customer_id: this.customer_id,
        start_time: this.startTime.substring(0, 10).replace(/\//g, '-'),
        end_time: this.endTime.substring(0, 10).replace(/\//g, '-'),
        // end_time: this.endTime,
        type: this.type,
        fee_type: this.projectName,
        page: this.pageNum,
        pagesize: this.pageSize
      }
      this.loading = true
      const _this = this
      getTransaction(params).then(response => {
        if (response.data && response.data.ask === 1 && response.data.data instanceof Object) {
          _this.tableData = response.data.data
          _this.totalcount = parseInt(response.data.total)
          // 用项目名称替换编号
          _this.tableData.forEach(function (val, index) {
            let arr = _this.allProject.filter(function (item) {
              if (item.value === val.project) {
                return item
              } else {
                return false
              }
            })
            if (arr.length > 0) {
              val.projectName = arr[0].text
            } else {
              val.projectName = ''
            }
          })
        } else {
          _this.tableData = []
          _this.totalcount = 0
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    getDetail (item) {
      const params = {
        id: item.id
      }
      getTransactionDetail(params).then(response => {
        console.log(response)
        if (response.data.ask === 1 && response.data.data) {
          this.flowBillDetail.basic_info = response.data.data.basic_info
          this.flowBillDetail.pay_info = response.data.data.pay_info
          this.flowBillDetail.order_info = response.data.data.order_info
          if (this.flowBillDetail.basic_info.project) {
            this.flowBillDetail.basic_info.projectName = ''
            this.allProject.forEach((value, index) => {
              if (value.value === this.flowBillDetail.basic_info.project) {
                this.flowBillDetail.basic_info.projectName = value.text
              }
            })
          } else {
            this.flowBillDetail.basic_info.projectName = ''
          }
        }
      }).catch(err => {
        console.log(err)
      })
      this.detailVisible = true
    },
    fliterType (value, row) {
      if (value === row.type) {
        return true
      }
    },
    filterProject (value, row) {
      if (value === row.project) {
        return true
      }
    },
    // 筛选请求数据
    handleFilterChange (filter) {
      // type:[] ,全部则数组为空
      let name = Object.keys(filter)[0]
      let value = filter[name]
      if (name === 'type') {
        if (value.length === 1) {
          this.type = value[0]
        } else {
          this.type = ''
        }
      } else if (name === 'projectName') {
        if (value.length === 1) {
          this.projectName = value[0]
        } else {
          this.projectName = ''
        }
      }
      if (this.pageNum !== 1) {
        this.pageNum = 1
      }
      this.getList()
    },
    // 单独处理时间的函数
    beginDate () {
      // 开始时间必须小于今天
      // let self = this
      return {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    },
    processDate () {
      // 结束时间大于开始时间
      let self = this
      return {
        disabledDate (time) {
          if (self.startTime_pop) {
            return (
              new Date(self.startTime_pop).getTime() > time.getTime() ||
                        time.getTime() > Date.now()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      }
    },
    cancelTime () {
      this.timeVisible = false
    },
    sureTime () {
      // 选中时间
      const _this = this
      const transformTime = this.dataTime(Date.now())
      let canSend = true
      // 时间处理
      switch (this.timeRadio) {
        case '1':
          _this.endTime = transformTime.date
          _this.startTime = _this.previousTime(7, transformTime.times)
          break
        case '2':
          _this.endTime = transformTime.date
          _this.startTime = _this.previousTime(30, transformTime.times)
          break
        case '3':
          _this.endTime = transformTime.date
          _this.startTime = _this.previousTime(90, transformTime.times)
          break
        case '4':
          // 选择自定义择必须选择时间
          if (!_this.startTime_pop || !_this.endTime_pop) {
            this.$message({
              message: 'Please choose the time',
              type: 'warning'
            })
            canSend = false
            return
          } else {
            // 时间比较
            if (_this.startTime_pop > _this.endTime_pop) {
              this.$message({
                message: 'The end time should not be greater than the start time',
                type: 'warning'
              })
              canSend = false
            } else {
              _this.startTime = _this.dataTime(_this.startTime_pop).date
              _this.endTime = _this.dataTime(_this.endTime_pop).date
            }
          }
          break
        default:
          canSend = false
          break
      }
      if (canSend) {
        _this.timeVisible = false
        _this.handelCurrentChange(1)
      }
    },
    clearTime () {
      this.startTime = ''
      this.endTime = ''
      if (this.timeRadio === '4') {
        // 自定义则置1
        this.timeRadio = '1'
        this.startTime_pop = ''
        this.endTime_pop = ''
      }
      // this.getList();
    },
    handelSizechange (pageSize) {
      if (!this.hasTime) {
        return
      }
      // 改变每页数据量
      this.pageSize = pageSize
      this.getList()
    },
    handelCurrentChange (pageNum) {
      if (!this.hasTime) {
        return
      }
      // 切换页码
      this.pageNum = pageNum
      this.getList()
    },
    // 时间格式转换
    dataTime (time) {
      const date = new Date(time)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + parseInt(date.getMonth() + 1) : date.getMonth() + 1
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // const newTime = Y+'-'+M+'-'+D+' '+H+':'+m+':'+s;
      const newTime = {
        date: Y + '-' + M + '-' + D + ' ' + H + ':' + m + ':' + s,
        times: H + ':' + m + ':' + s
      }
      return newTime
    },
    previousTime (num, times) {
      var _date = new Date() // 获取今天日期
      _date.setDate(_date.getDate() - num) // 日期回到七天前
      let Y = _date.getFullYear()
      let M = _date.getMonth() + 1 < 10 ? '0' + parseInt(_date.getMonth() + 1) : _date.getMonth() + 1
      let D = _date.getDate() < 10 ? '0' + _date.getDate() : _date.getDate()
      const prevTime = Y + '-' + M + '-' + D + ' ' + times
      return prevTime
    }
  }
}
</script>
<style scoped>
ul li {
    list-style: none;
}
.green {
    color: #67c23a;
}
.floatL {
    float: left;
}
.floatR {
    float: right;
}
.clearfix {
    overflow: hidden;
    _zoom: 1;
}
.centers {
    margin-top: 20px;
    padding: 20px;
    border: 1px solid #dcdfe6;
}
.centers > .timeTab {
    line-height: 30px;
    height: 40px;
}
.timeTab > .delBtn {
    padding: 0 10px;
    cursor: pointer;
    /* font-style: italic; */
    color: #d66c6c;
}
.timeTab > .delBtn:hover {
    color: #ea5151;
    text-decoration: underline;
}
.tableTab > .searchTab {
    text-align: left;
    margin: 10px 0;
}
.searchTab > span.name {
    margin: 0 10px;
}
.popTab {
    padding: 0 20px;
    text-align: left;
}
.popTab > p.perItem {
    margin-bottom: 15px;
}
.violet, .violet:hover {
    background: rgb(137, 137, 186);
    color: rgb(255, 255, 255);
    outline: none;
}
.popTab > .perPart {
    margin: 0;
    padding: 0;
}
.popTab > .perPart > li.header {
    border-bottom: 1px solid #dcdfe6;
}
.popTab > .perPart > li {
    line-height: 32px;
    width: 100%;
}
.popTab > .perPart > li span {
    display: inline-block;
    width: 135px;
    padding-right: 5px;
    text-align: right;
}
.popTab > .perPart > li b {
    text-align: left;
    width: calc(100% - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/views/Finance/flowBill.vue